import React from "react";

/**
 * Main Jila Hoon emblem — minimalist jharokha (royal arched window)
 * with a topographic contour line and tagline below.
 */
export default function Logo({ compact = false, className = "" }) {
    return (
        <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
            <svg
                viewBox="0 0 64 64"
                width={compact ? 32 : 40}
                height={compact ? 32 : 40}
                fill="none"
                aria-hidden
            >
                {/* Jharokha outer arch */}
                <path
                    d="M8 56 V30 C8 18 18 8 32 8 C46 8 56 18 56 30 V56"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                {/* Inner trefoil arch */}
                <path
                    d="M18 56 V32 C18 24 24 18 32 18 C40 18 46 24 46 32 V56"
                    stroke="currentColor"
                    strokeWidth="1"
                    opacity="0.55"
                />
                {/* Topographic contour through arch */}
                <path
                    d="M14 44 Q 28 38 32 42 T 50 44"
                    stroke="#C05640"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    fill="none"
                />
                {/* Apex finial */}
                <circle cx="32" cy="5" r="1.6" fill="#E6A123" />
                <line x1="32" y1="5" x2="32" y2="9" stroke="#E6A123" strokeWidth="1" />
                {/* Base line */}
                <line x1="6" y1="58" x2="58" y2="58" stroke="currentColor" strokeWidth="1" />
            </svg>
            {!compact && (
                <div className="leading-none">
                    <div className="font-display text-[18px] md:text-[20px] ink tracking-tight">
                        Main Jila Hoon
                    </div>
                    <div className="font-data text-[9px] tracking-[0.22em] uppercase ink-mute mt-1">
                        I Am The District
                    </div>
                </div>
            )}
        </div>
    );
}
